<script>
    import Dialog, {Title, Content, Actions, InitialFocus} from '@smui/dialog';
    import Button, {Group, GroupItem, Label, Icon} from '@smui/button';

    let eventDialog;

    export function open() {
        eventDialog.setOpen(true);
    }

</script>

<Dialog bind:this={eventDialog}>
    <Title id="title">Warning</Title>
    <Content id="content">
        This organization has users slected specifically for it
    </Content>
    <Actions>
        <Button>
            <Label>Close</Label>
        </Button>
    </Actions>
</Dialog>